import React, {useCallback, useMemo} from 'react';
import _ from 'lodash';
import {evoAppsUserToSerialID, parseEvoAppsUserSerialID} from 'module/SessionInfo/util/SwitchUserUtil';
import {switchUserHandler} from 'module/SessionInfo/api/SwitchUserAPI';
import {EvoAppsUserLabel} from 'module/SessionInfo/component/userInfo/EvoAppsUserLabel';
import {EvoAppsUserTO, EvoAppsUserWrapperTO} from 'generated/JavaTO';
import {SlctLabelOnly} from 'module/Slct/component/SlctLabelOnly'
import {filterOptionsSlct, filterOptionsSlctNoValue} from 'module/Slct/util/filterOptionsSlct'
import {SlctOption} from 'module/Slct/type/SlctType'
import {MEMO_KEY_SWITCH_USER} from 'module/Memo/util/MemoKey'


const mapToSelectValue = (user: EvoAppsUserTO, defaultEvoAppsUser: EvoAppsUserTO) => ({
	value: evoAppsUserToSerialID(user, defaultEvoAppsUser),
	// label for search only
	label: [user.longUsername, user.text, user.userGroup.id, user.userGroup.description].join(" "),
	jsx: <EvoAppsUserLabel user={user} defaultUser={defaultEvoAppsUser}/>,
	model: user,
});

export const SwitchUserComponent = React.memo<{ evoAppsUser: EvoAppsUserWrapperTO }>(({evoAppsUser}) => {
	const {alternativeUsers, defaultEvoAppsUser} = evoAppsUser || {};
	const disabled = _.isEmpty(alternativeUsers);
	const value = evoAppsUserToSerialID(evoAppsUser, defaultEvoAppsUser)
	const options = useMemo(() => {
		return [
			defaultEvoAppsUser,
			...alternativeUsers,
		].sort((a, b) => {
			if (a.username === defaultEvoAppsUser.username && a.userGroup.id === defaultEvoAppsUser.userGroup.id) return -1
			if (b.username === defaultEvoAppsUser.username && b.userGroup.id === defaultEvoAppsUser.userGroup.id) return 1
			if (a.longUsername !== b.longUsername) return a.longUsername.localeCompare(b.longUsername)
			if (a.userGroup.id !== b.userGroup.id) return a.userGroup.id.localeCompare(b.userGroup.id)
			if (a.userGroup.description !== b.userGroup.description) return a.userGroup.id.localeCompare(b.userGroup.description)
			return 0
		}).map(u => mapToSelectValue(u, defaultEvoAppsUser))
	}, [defaultEvoAppsUser, alternativeUsers])
	return (
		<SlctLabelOnly
			disabled={disabled}
			value={value}
			options={options}
			filterOptions={filterOptionsSlctNoValue}
			onChange={useCallback((u: SlctOption<EvoAppsUserTO, string>) => u.value && switchUserHandler(parseEvoAppsUserSerialID(u.value)), [])}
			memo={{
				memoKey: MEMO_KEY_SWITCH_USER,
				memoSize: 10,
				memoAutoAdd: false,
			}}
		/>
	);
});